/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const KEY = 'logoutUrls';

export default {
  add(url) {
    let logoutUrls = JSON.parse(localStorage.getItem(KEY)) || [];
    if (logoutUrls.indexOf(url) === -1) {
      logoutUrls.push(url);
      localStorage.setItem(KEY, JSON.stringify(logoutUrls));
    }
  },

  async invoke() {
    let logoutUrls = JSON.parse(localStorage.getItem(KEY)) || [];
    try {
      await Promise.all(logoutUrls.map(url => fetch(url, {credentials: 'include', redirect: 'manual'})));
    } catch (e) {
      // noop
    }
  },

  remove() {
    localStorage.removeItem(KEY);
  }
};
